import { BookingFlow } from "../components/BookingFlow";

export default function Booking() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-testid="booking-page">
      <div className="text-center mb-10">
        <span className="inline-block bg-[#D9E4E1] text-slate-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
          In-Clinic Appointment · Banjara Hills
        </span>
        <h1 className="font-heading text-3xl md:text-4xl text-slate-900">Book your visit</h1>
      </div>
      <BookingFlow type="clinic" />
    </div>
  );
}
